import React, { memo } from 'react';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { logger } from '@fiverr-private/obs';
import { Stack } from '@fiverr-private/layout_components';
import { translate } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import {
    Certifications,
    Courses,
    Educations,
    useSellerData,
    SellerPageFederatedSeller,
} from '@fiverr-private/seller_pages_toolbox';
import { subtitleClass } from './styles.ve.css';

const onRenderError = (originalError) => {
    const err = new Error('Failed while rendering the EducationSection Component');
    logger.error(err, {
        cause: originalError,
    });
};

export const EducationSection = memo(() => {
    const { courses, activeEducations, certifications } = useSellerData(selectSellerSlice);

    return (
        <ErrorBoundary onError={onRenderError}>
            <Stack direction="column" gap="12">
                {!!activeEducations.length && (
                    <Educations
                        customTitle={
                            <Typography
                                size={{ default: 'h_sm', lg: 'h_md' }}
                                fontWeight="bold"
                                color="grey_1200"
                                marginBottom="3"
                            >
                                {translate('seller_pages_toolbox.modal.education.title')}
                            </Typography>
                        }
                        contentTitleClassName="tbody-5"
                        subtitleClassName={subtitleClass}
                    />
                )}
                {!!certifications.length && (
                    <Certifications
                        customTitle={
                            <Typography
                                size={{ default: 'h_sm', lg: 'h_md' }}
                                fontWeight="bold"
                                color="grey_1200"
                                marginBottom="3"
                            >
                                {translate('seller_pages_toolbox.modal.certifications.title')}
                            </Typography>
                        }
                        contentTitleClassName="tbody-5"
                        subtitleClassName={subtitleClass}
                    />
                )}
                {!!courses?.nodes?.length && (
                    <Courses
                        customTitle={
                            <Typography size={{ default: 'h_sm', lg: 'h_md' }} fontWeight="bold" color="grey_1200">
                                {translate('seller_pages_toolbox.modal.fiverr_learn.title')}
                            </Typography>
                        }
                        contentTitleClassName="tbody-5"
                        subtitleClassName={subtitleClass}
                    />
                )}
            </Stack>
        </ErrorBoundary>
    );
});

EducationSection.displayName = 'EducationSection';

function selectSellerSlice(seller: SellerPageFederatedSeller) {
    return {
        courses: seller.courses,
        activeEducations: seller.activeEducations,
        certifications: seller.certifications,
    };
}
